import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-label',
  templateUrl: './icon-label.component.html',
  styleUrls: ['./icon-label.component.scss']
})
export class IconLabelComponent implements OnInit {

  @Input() iconId: string;
  @Input() iconColor: string;
  @Input() label: string;
  @Input() size: number = 40;
  @Input() border: 'none'|'square'|'circle' = 'none'
  @Input() clickable: boolean = false
  @Input() selected: boolean = false

  hover:boolean

  constructor() { }

  ngOnInit(): void {
  }

}
